module.exports = __webpack_public_path__ + "static/media/truck.899916eb.png";